<template>
    <v-container>
            <v-row class="py-12" align="center" justify="center" no-gutters>
                <v-col class="form">
                    <h1 class="display-1 font-weight-bold primary--text mb-4">
                        Confirm Account
                    </h1>
                    <h2 class="subtitle-1 mb-8">
                        Enter code
                    </h2>
                    <v-form
                        class="text-center"
                        @submit.prevent="onContinue"
                    >
                        <v-text-field
                            autofocus
                            aria-required
                            required
                            name="tfa-code"
                            v-validate="'required'"
                            validate-on-blur
                            :error-messages="errors.first('tfa-code')"
                            type="text"
                            label="Two Factor Authentication Code"
                            append-icon="mdi-email-outline"
                            background-color="#fcfcfc"
                            v-model="tfaCode"
                            outlined
                            ref="tfa-code"
                        >
                        </v-text-field>

                        <v-row no-gutters class="align-center">
                            <v-col>
                                <v-btn
                                    class="px-12 text--white"
                                    color="primary"
                                    block
                                    text
                                    depressed
                                    x-large
                                    @click.prevent="resendCode"
                                >
                                     Resend code
                                </v-btn>
                            </v-col>
                            <v-col class="text-right">
                                <v-btn
                                    class="px-12 text--white"
                                    color="primary"
                                    block
                                    dark
                                    depressed
                                    x-large
                                    @click.prevent="onContinue"
                                >
                                    Continue
                                </v-btn>
                            </v-col>
                            <v-col class="mt-3">
                                <v-btn
                                  class="px-6"
                                  text
                                  color="red darken-2"
                                  large
                                  @click="$emit('update:show', false)"
                                >
                                    Cancel
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
          userId: String,
          token: Object,
        },
        data: function() {
            return {
                tfaCode: '',
            };
        },
        methods: getMethods(),
    };

    function getMethods() {
        return {
            onContinue,
            resendCode,
        };

        function onContinue() {
            const vm = this;

            vm.$validator.validateAll().then(submitIfValid);

            function submitIfValid(formIsValid) {
                if(formIsValid){
                    vm.$emit('loading');
                    const payload = {
                        tfaCode: parseInt(vm.tfaCode),
                    };

                    const authorizationHeader = vm.token ? `${vm.token.token_type} ${vm.token.access_token}` : null;
                    Vue.backendApi().user(vm.userId)
                        .tfaConfirm(payload, authorizationHeader)
                        .then(success)
                        .catch(error);
                }
            }

            function success(response) {
                vm.$emit('loaded');
                vm.$emit('success', response);
            }

            function error(error) {
                vm.$emit('loaded');
                vm.$emit('error', error);
            }
        }

        function resendCode() {
            const vm = this;
            vm.$emit('loading');
            const authorizationHeader = vm.token ? `${vm.token.token_type} ${vm.token.access_token}` : null;
            Vue.backendApi().user(vm.userId)
                .resendTfaCode({}, authorizationHeader)
                .then(success)
                .catch(error);

            function success(response) {
                vm.$swal({
                  type: 'success',
                  title: 'Code has been resent',
                });
                vm.$emit('loaded');
            }

            function error(error) {
                vm.$swal({
                  type: 'error',
                  text: error,
                });
                vm.$emit('loaded');
            }
        }
    }

</script>
<style scoped>
    .form {
        text-align: center;
        max-width: 350px;
    }
</style>
